import { supabase, isSupabaseConfigured } from '../supabase-client.ts';

const PROGRESS_TABLE = 'user_progress';

const userProgressService = {
  // Get user progress from Supabase
  async getUserProgress(userId, bookId) {
    try {
      if (!isSupabaseConfigured || !supabase || !userId || !bookId) {
        return null;
      }

      const { data, error } = await supabase
        .from(PROGRESS_TABLE)
        .select('current_chapter, last_read')
        .eq('user_id', userId)
        .eq('book_id', bookId)
        .maybeSingle();

      if (error || !data) {
        return null;
      }

      return {
        last_chapter_id: data.current_chapter,
        last_accessed_at: data.last_read
      };
    } catch (error) {
      return null;
    }
  },

  // Update user progress in Supabase
  async updateUserProgress(userId, bookId, chapterId) {
    try {
      if (!isSupabaseConfigured || !supabase || !userId || !bookId || !chapterId) {
        return false;
      }

      const payload = {
        user_id: userId,
        book_id: bookId,
        current_chapter: chapterId,
        last_read: new Date().toISOString()
      };

      const { error } = await supabase
        .from(PROGRESS_TABLE)
        .upsert(payload, { onConflict: 'user_id,book_id' });

      if (error) {
        return false;
      }

      return true;
    } catch (error) {
      return false;
    }
  },

  // Alternative approach: Store progress in localStorage as fallback
  getLocalProgress(bookId) {
    try {
      const progress = localStorage.getItem(`progress_${bookId}`);
      return progress ? JSON.parse(progress) : null;
    } catch (error) {
      return null;
    }
  },

  setLocalProgress(bookId, chapterId) {
    try {
      const progress = {
        last_chapter_id: chapterId,
        last_accessed_at: new Date().toISOString()
      };
      localStorage.setItem(`progress_${bookId}`, JSON.stringify(progress));
      return true;
    } catch (error) {
      return false;
    }
  },

  // Combined approach: Try database first, fallback to localStorage
  async getProgress(userId, bookId) {
    const dbProgress = await this.getUserProgress(userId, bookId);
    if (dbProgress) {
      return dbProgress;
    }

    // Fallback to localStorage
    return this.getLocalProgress(bookId);
  },

  async setProgress(userId, bookId, chapterId) {
    const dbSuccess = await this.updateUserProgress(userId, bookId, chapterId);

    // Always update localStorage as backup
    const localSuccess = this.setLocalProgress(bookId, chapterId);

    return dbSuccess || localSuccess;
  }
};

export default userProgressService; 